import { breakdanceStoreActions } from "@/store/actions/store-actions";
import { findNode } from "@/lib/tree/tree";
import { documentStore, uiStore } from "@/store/store";
import {
  FUTURELAYER_HEADER_ELEMENT_TYPE,
  FUTURELAYER_FOOTER_ELEMENT_TYPE
} from "./headers-footers";
import { fetchHeaderAndFooterBlockIdsAndSyncToStore } from "./api";
import { findFirstChildOfElementBeingInlineEdited } from "@/lib/singularity/page-structure/api-for-global-block-inline-editing";
import { SECTION_SLUG } from "@/lib/elements/constants";
import lodash from "lodash";
import {
  addElementIdToBackgroundGeneratingHeadersAndFootersInStore,
  backgroundPageGenerationService
} from "../pages/background-page-generation-service";
import { forceNextTick } from "@/util/force-next-tick";
import { registerOverlayHeaderActions } from "./overlay-headers";


export function registerHeaderFooterActions() {
  registerOverlayHeaderActions();

  breakdanceStoreActions.register.onMountedElement(async ({ elementId }) => {
    const element = findNode(documentStore.document.tree, elementId);

    if (
      !element ||
      (element.data.type !== FUTURELAYER_HEADER_ELEMENT_TYPE &&
        element.data.type !== FUTURELAYER_FOOTER_ELEMENT_TYPE)
    ) {
      return;
    }

    const currentBlockId = lodash.get(
      element.data.properties,
      "content.content.block"
    );
    if (currentBlockId) {
      return;
    }

    const blockIds = await fetchHeaderAndFooterBlockIdsAndSyncToStore();

    let blockId = null;

    if (element.data.type === FUTURELAYER_HEADER_ELEMENT_TYPE) {
      blockId = blockIds.header;
    } else if (element.data.type === FUTURELAYER_FOOTER_ELEMENT_TYPE) {
      blockId = blockIds.footer;
    }

    if (blockId) {
      documentStore.unthrottledPropertyChanged({
        elementId: element.id,
        path: "content.content.block",
        value: blockId,
        meta: {
          snapshotLabel: `Auto-populated header/footer block ID`
        }
      });

      if (
        backgroundPageGenerationService
          .getGeneratingBlockIds()
          .includes(blockId)
      ) {
        addElementIdToBackgroundGeneratingHeadersAndFootersInStore(element.id);
      }
    }
  });


  breakdanceStoreActions.register.onMountedElement(({ elementId }) => {
    if (!uiStore.isInlineEditing) return;

    const element = findNode(documentStore.document.tree, elementId);

    if (!element || element.data.type !== SECTION_SLUG) {
      return;
    }

    forceNextTick(() => {
      const firstChildOfInlineElement =
        findFirstChildOfElementBeingInlineEdited();
      if (firstChildOfInlineElement === elementId) {
        uiStore.activateElement(elementId);
      }
    });
  });
}
